import g2users from 'images/auth/g2_badge_users_love_us.svg';
import React from 'react';
import styles from './AuthPage.module.scss';

const Testimonials: React.FC = () => (
  <div className={styles.testimonialContainer}>
    <h2>Top rated time tracking</h2>
    <div className={styles.g2Container}>
      <img
        alt="Timely has the Best Support in Enterprise Time Tracking on G2"
        src="https://images.g2crowd.com/uploads/report_medal_translation/image/38580/medal.svg"
        width="116"
        height="150"
      />
      <img alt="Users love Timely on G2" src={g2users} width="116" height="150" />
      <img
        alt="Timely is a leader in Time Tracking on G2"
        src="https://images.g2crowd.com/uploads/report_medal_translation/image/38891/medal.svg"
        width="116"
        height="150"
      />
    </div>
    <div className={styles.testimonialItems}>
      <h3>&ldquo;The best way to measure exactly where your time goes.&rdquo;</h3>
      <div>
        <span>Brian,</span>
        Accountant
      </div>
    </div>
    <div className={styles.testimonialItems}>
      <h3>&ldquo;Timely takes a load off my brain.&rdquo;</h3>
      <div>
        <span>Erik,</span>
        Digital Designer
      </div>
    </div>
    <div className={styles.testimonialItems}>
      <h3>&ldquo;Easy to use and I love the project level summaries.&rdquo;</h3>
      <div>
        <span>Jonathan,</span>
        Software Engineer
      </div>
    </div>
  </div>
);

export default Testimonials;
